import React from "react"
import { defaultGroundTruthSort } from "../../../Models/API/APIGroundTruthModel"
import { routePaths } from "../.."
import { AppCustomizeBaselineData } from "../../../Components/Views/Dashboard/Sections/AppDetail/Customize/Modes/BaselineData/BaselineData"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"

export function AppGroundTruthDataRoute({
    match,
    location
}: AppDetailRouteComponentProps<{
    baselineID?: string
}>) {
    const filterAndSort = useDecodeFilterAndSort(
        location.search,
        defaultGroundTruthSort,
        routePaths.appCustomizeBaselineData(
            match.params.orgUsername,
            match.params.appID
        )
    )
    const open = new URLSearchParams(location.search).get("open") === "true"

    return (
        <AppAuthCheck {...match.params} scope="ground-truth:view">
            <AppCustomizeBaselineData
                {...match.params}
                groundTruthID={open ? null : match.params.baselineID}
                filterAndSort={filterAndSort}
            />
        </AppAuthCheck>
    )
}
